import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/utils/api";
import { Section } from "@/components/dashboard/DashboardPrimitives";
import { downloadCertificate, downloadCertificateImage, RESULT_COPY } from "@/components/quiz/quizUtils";

export default function ParentQuizCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/api/quiz/status").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  const code = s.personal_code;

  const dl = (a) => downloadCertificate(a).catch((e) => toast.error(formatApiError(e)));
  const dlImg = (a) => downloadCertificateImage(a).catch((e) => toast.error(formatApiError(e)));

  return (
    <Section title="Parent Quiz" description="Your test results, certificates and personal discount code." testid="parent-quiz-section"
      right={<Link to="/parent-quiz" className="text-sm px-3 py-1.5 rounded bg-sky-500 hover:bg-sky-400 text-white" data-testid="parent-quiz-open-link">{s.attempts.length ? "Open quiz" : "Take the free quiz"}</Link>}>
      {code && (
        <div className="rounded-xl border border-amber-300/30 bg-amber-300/5 p-4 mb-4 flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="parent-quiz-code">
          <span className="text-xs uppercase tracking-wider text-amber-200">Personal code</span>
          <code className="text-lg text-white font-semibold">{code.code}</code>
          <span className="text-xs text-slate-400">₹{code.price.INR} + GST / ${code.price.USD} per report · Growth {code.uses.growth ? "used" : "available"} · NutriGuide {code.uses.nutrition ? "used" : "available"}</span>
        </div>
      )}
      <div className="rounded-xl bg-[#0E1A3A] border border-slate-800 divide-y divide-slate-800/80">
        {s.attempts.length === 0 && <p className="p-6 text-sm text-slate-400">You haven't taken the quiz yet. It's free, takes 15 minutes, and unlocks ₹299 reports.</p>}
        {s.attempts.map((a) => {
          const r = RESULT_COPY[a.result] || RESULT_COPY.good;
          return (
            <div key={a.attempt_id} className="p-4 flex flex-wrap items-center gap-3" data-testid={`parent-quiz-attempt-${a.attempt_id}`}>
              <span className="text-lg font-semibold text-white">{a.score}/{a.total}</span>
              <span className="text-[11px] uppercase px-2 py-0.5 rounded" style={{ color: r.color, background: `${r.color}22` }}>{r.label}</span>
              <span className="text-xs text-slate-400 flex-1">{new Date(a.completed_at).toLocaleString()} · {a.certificate_no}</span>
              <button onClick={() => dl(a)} className="text-xs px-3 py-1.5 rounded border border-slate-600 text-slate-200 hover:bg-slate-700/40" data-testid={`parent-quiz-cert-${a.attempt_id}`}>Certificate PDF</button>
              <button onClick={() => dlImg(a)} className="text-xs px-3 py-1.5 rounded border border-slate-600 text-slate-200 hover:bg-slate-700/40" data-testid={`parent-quiz-cert-img-${a.attempt_id}`}>Image</button>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
